<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <form class="form" [formGroup]="model" (ngSubmit)="submit()">

            <div class="row">
                <div class="col-12">
                    <h1 class="title-default">Usuários</h1>
                    <p class="welcome-message">
                        <button mat-icon-button type="button" (click)="cancelar()">
                            <mat-icon>arrow_back</mat-icon>
                        </button>
                        Configurações e preferências do cadastro de usuários.
                    </p>
                </div>
            </div>
            @if(this.idUsuario){
            <a mat-button class="btn-link" (click)="abrirModalAlterarSenhaUsuario()">
                <mat-icon>key</mat-icon>
                Alterar senha usuário
            </a>
            }
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="email" type="email" (keypress)="disableFields()">
                        <mat-icon class="material-icons-outlined" matSuffix
                            matTooltip="O email será usado para realizar login e não pode ser alterado após a criação do usuário">info_outline</mat-icon>
                        @if (model.get('email')?.invalid) {
                        <mat-error>Informe o e-mail</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    @if(!this.idUsuario){
                    <button type="button" mat-stroked-button class="btn-secondary" (click)="verificaEmail()">
                        @if (_isLoadingVerificarEmail === true) {
                        <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                        }
                        @else{
                        <span>Verificar email</span>
                        }
                    </button>
                    }
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-label>Nome</mat-label>
                        <input matInput formControlName="nomeUsuario" type="text">
                        @if (model.get('nomeUsuario')?.invalid) {
                        <mat-error>Informe o nome</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-label>Telefone</mat-label>
                        <input matInput formControlName="telefone" type="text" [mask]="masks.phone">
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-label>CPF</mat-label>
                        <input matInput formControlName="cpf" type="text" [mask]="masks.cpf">
                        @if (model.get('cpf')?.invalid) {
                        <mat-error>Informe um CPF válido</mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    @if (!idUsuario) {
                    <app-alert-card type="info" [icon]="'info'">
                        <span>
                            <strong>Para novos usuários:</strong> Ao criar um novo usuário, ele receberá um e-mail com a
                            senha
                            temporária para começar a usar o sistema.
                        </span>
                    </app-alert-card>
                    }
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="col-12">
                        <h1 class="subtitle-default">Acessos</h1>
                    </div>
                </div>
                <div class="col-md-3">
                    <mat-form-field appearance="outline">
                        <mat-label>Perfil</mat-label>
                        <mat-icon class="material-icons-outlined" matSuffix
                            matTooltip="Você só pode selecionar os perfis da sua empresa logada">info_outline</mat-icon>
                        <mat-select formControlName="listaIdPerfil" multiple>
                            @if(_usuarioLookupResponse){
                            @for (perfil of _usuarioLookupResponse.listaPerfil; track perfil) {
                            <mat-option [value]="perfil.idPerfil">{{perfil.nome}}</mat-option>
                            }
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-slide-toggle class="app-toggle-compact" formControlName="master">
                        Usuário master
                        <mat-icon class="material-icons-outlined" matSuffix
                            matTooltip="Um usuário 'master' possui todas as permissões atribuídas a ele, independentemente do perfil que tenha.">info_outline</mat-icon>
                    </mat-slide-toggle>

                </div>
            </div>
        </form>

        <!-- Restrições ativas vinculadas ao usuário -->
        @if (idUsuario) {
        <div class="user-restrictions-section">
            <h1 class="subtitle-default">Restrições Ativas</h1>
            <p class="user-restrictions-description">
                As restrições abaixo são aplicadas a este usuário conforme os perfis vinculados a ele.
                Usuário master ignora todas as restrições.
            </p>

            @if (listaRestricaoPerfil.length === 0 && temPerfisSelecionados()) {
            <p class="restriction-none">
                Nenhuma restrição ativa foi encontrada para os perfis vinculados.
            </p>
            }

            @for (restricao of listaRestricaoPerfil; track restricao.idPerfil) {
            <div class="restriction-profile-card">
                <div class="restriction-profile-header">
                    <mat-icon class="restriction-profile-icon">manage_accounts</mat-icon>
                    <span class="restriction-profile-name">{{restricao.nomePerfil}}</span>
                </div>

                <!-- IP Restrictions -->
                @if (restricao.listaIpRestrito?.length) {
                <div class="restriction-detail-block">
                    <div class="restriction-detail-label">
                        <mat-icon class="detail-icon">router</mat-icon>
                        <span>IPs permitidos</span>
                    </div>
                    <div class="ip-tags">
                        @for (ip of restricao.listaIpRestrito; track $index) {
                        <span class="ip-tag">
                            <mat-icon class="ip-tag-icon">computer</mat-icon>
                            {{ip}}
                        </span>
                        }
                    </div>
                </div>
                }

                <!-- Schedule Restrictions -->
                @if (restricao.listaAcessoHorario?.length) {
                <div class="restriction-detail-block">
                    <div class="restriction-detail-label">
                        <mat-icon class="detail-icon">schedule</mat-icon>
                        <span>Horários permitidos</span>
                    </div>
                    <div class="schedule-tags">
                        @for (horario of restricao.listaAcessoHorario; track $index) {
                        <span class="schedule-tag">
                            <strong>{{diasSemana[horario.diaSemana]}}</strong>
                            {{horario.horaInicio}} – {{horario.horaFim}}
                        </span>
                        }
                    </div>
                </div>
                }

                @if (!restricao.listaIpRestrito?.length && !restricao.listaAcessoHorario?.length) {
                <p class="restriction-none">
                    Sem restrições configuradas neste perfil.
                </p>
                }
            </div>
            }
        </div>
        }
    </div>
</div>

<app-footer-action
  [isLoadingSalvar]="_isLoading"
  [isSalvarDisabled]="btnSalvarDisable"
  (cancelar)="cancelar()"
  (salvar)="submit()"></app-footer-action>
